import type { ActionTree } from 'vuex/types/index.js';

export const APP_ACTIONS: ActionTree<Record<string, unknown>, Record<string, unknown>> = {
  resetState({ commit }): void {
    commit('RESET_STATE');
  },
};
